module.exports = __webpack_public_path__ + "media/images/advisor/img_2_3-2d50b55947aafc0ca4a71ce2a06c3e81.png";